import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetCallPriceUnit extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/GetCallUnitPrice");
  }
}

class SetCallPriceUnit extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/SetCallUnitPrice");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetLeaderboardSetting extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/GetLeaderboardSettings");
  }
}

class SetLeaderboardSetting extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/SetLeaderboardSettings");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class SetPopularMasterDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/SetPopularMasterCountAndPercent");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetPopularMasterDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SiteSetting/GetPupularMasterCountAndPercent");
  }
}

export {
  GetCallPriceUnit,
  SetCallPriceUnit,
  GetLeaderboardSetting,
  SetLeaderboardSetting,
  SetPopularMasterDetails,
  GetPopularMasterDetails,
};
